var data = {
	v: "5.5.2",
	nm: "Icon-PartlyRight",
	ddd: 0,
	assets: [
	],
	w: 300,
	h: 300,
	ip: 0,
	op: 270,
	fr: 100,
	fonts: {
		list: [
		]
	},
	layers: [
		{
			ty: 4,
			st: 0,
			ip: 0,
			op: 270,
			ks: {
				a: {
					a: 0,
					k: [
						35.625,
						35.625
					]
				},
				p: {
					a: 0,
					k: [
						152.641804,
						154.966104
					]
				},
				s: {
					a: 1,
					k: [
						{
							t: 0,
							s: [
								150,
								150
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 20,
							s: [
								237.2482,
								237.2482
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 40,
							s: [
								203.996,
								203.996
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 60,
							s: [
								222.581,
								222.581
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 80,
							s: [
								203.996,
								203.996
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						}
					]
				},
				o: {
					a: 1,
					k: [
						{
							t: 0,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 20,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						}
					]
				}
			},
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															56,
															60.2787
														],
														[
															59.2565,
															64
														],
														[
															65,
															56
														]
													],
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: false
												}
											}
										},
										{
											ty: "st",
											o: {
												a: 0,
												k: 100
											},
											w: {
												a: 0,
												k: 3
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											},
											ml: 4,
											d: [
												{
													n: "d",
													nm: "dash 0",
													v: {
														a: 0,
														k: 0.1
													}
												},
												{
													n: "g",
													nm: "gap 0",
													v: {
														a: 0,
														k: 4
													}
												},
												{
													n: "o",
													nm: "offset",
													v: {
														a: 0,
														k: 0
													}
												}
											]
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													60.5,
													60
												]
											},
											p: {
												a: 0,
												k: [
													60.5,
													60
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													22.5,
													22.5
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.737255,
													0.529412,
													0
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											p: {
												a: 0,
												k: [
													60,
													60
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											60,
											60
										]
									},
									p: {
										a: 0,
										k: [
											60.11803,
											62.527743
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													1.320754,
													2.6415
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													24.4338,
													25.094401
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													3.96226,
													6.60378
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.129412,
													0.137255,
													0.184314
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													25.7546,
													27.075601
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													9.24528,
													11.8868
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													-1e-6,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													24.434199,
													25.754701
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													1.320754,
													2.6415
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0.000001,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													45.566101,
													25.094401
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													3.96226,
													6.60378
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.129412,
													0.137255,
													0.184314
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0.000004,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													46.886904,
													27.075601
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													9.24528,
													11.8868
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0.000004,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													45.566004,
													25.754701
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											35.000102,
											25.754701
										]
									},
									p: {
										a: 0,
										k: [
											35.000102,
											25.754701
										]
									},
									s: {
										a: 1,
										k: [
											{
												t: 150,
												s: [
													100,
													100
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 160,
												s: [
													100,
													0
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 170,
												s: [
													100,
													100
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 180,
												s: [
													100,
													100
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 190,
												s: [
													100,
													0
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 200,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											}
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "el",
									p: {
										a: 0,
										k: [
											0,
											0
										]
									},
									s: {
										a: 0,
										k: [
											23,
											13
										]
									}
								},
								{
									ty: "gf",
									o: {
										a: 0,
										k: 100
									},
									s: {
										a: 0,
										k: [
											0,
											0
										]
									},
									e: {
										a: 0,
										k: [
											0,
											6.5
										]
									},
									g: {
										p: 2,
										k: {
											a: 0,
											k: [
												0,
												0.984314,
												0.196078,
												0.196078,
												1,
												1,
												0.396078,
												0.396078,
												0,
												1,
												1,
												0
											]
										}
									},
									t: 2
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									p: {
										a: 0,
										k: [
											13.5,
											36.5
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "el",
									p: {
										a: 0,
										k: [
											0,
											0
										]
									},
									s: {
										a: 0,
										k: [
											20,
											12
										]
									}
								},
								{
									ty: "gf",
									o: {
										a: 0,
										k: 100
									},
									s: {
										a: 0,
										k: [
											0,
											0
										]
									},
									e: {
										a: 0,
										k: [
											0,
											6
										]
									},
									g: {
										p: 2,
										k: {
											a: 0,
											k: [
												0,
												0.984314,
												0.196078,
												0.196078,
												1,
												1,
												0.396078,
												0.396078,
												0,
												1,
												1,
												0
											]
										}
									},
									t: 2
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									p: {
										a: 0,
										k: [
											55,
											38
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													40.267,
													16.3364
												],
												[
													40.1198,
													17.7429
												],
												[
													41.5263,
													17.8901
												],
												[
													40.267,
													16.3364
												]
											],
											i: [
												[
													0,
													0
												],
												[
													-0.3478,
													-0.4291
												],
												[
													-0.4291,
													0.3478
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-0.4291,
													0.3477
												],
												[
													0.3477,
													0.429
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													54.6032,
													14.8878
												],
												[
													40.267,
													16.3364
												],
												[
													41.5263,
													17.8901
												],
												[
													53.3763,
													16.4672
												],
												[
													54.6032,
													14.8878
												]
											],
											i: [
												[
													0,
													0
												],
												[
													6.2505,
													-5.0657
												],
												[
													0,
													0
												],
												[
													-1.6018,
													-1.2442
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-2.2521,
													-1.7494
												],
												[
													0,
													0
												],
												[
													5.4491,
													-4.4162
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "fl",
									o: {
										a: 0,
										k: 100
									},
									c: {
										a: 0,
										k: [
											0,
											0,
											0
										]
									}
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											47.249899,
											15.583658
										]
									},
									p: {
										a: 0,
										k: [
											47.249899,
											15.583658
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													37.6833,
													58.4519
												],
												[
													38.6408,
													57.4111
												],
												[
													37.6,
													56.4536
												],
												[
													37.6833,
													58.4519
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0.023,
													0.5518
												],
												[
													0.5518,
													-0.023
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0.5518,
													-0.023
												],
												[
													-0.023,
													-0.5518
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													17.5272,
													46.494
												],
												[
													37.6833,
													58.4519
												],
												[
													37.6,
													56.4536
												],
												[
													19.4542,
													45.9587
												],
												[
													17.5272,
													46.494
												]
											],
											i: [
												[
													0,
													0
												],
												[
													-13.1945,
													0.5497
												],
												[
													0,
													0
												],
												[
													0.9905,
													3.5656
												],
												[
													0,
													0
												]
											],
											o: [
												[
													1.2108,
													4.3589
												],
												[
													0,
													0
												],
												[
													-12.1639,
													0.5068
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "fl",
									o: {
										a: 0,
										k: 100
									},
									c: {
										a: 0,
										k: [
											0,
											0,
											0
										]
									}
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											28.084443,
											52.218531
										]
									},
									p: {
										a: 0,
										k: [
											28.084443,
											52.218531
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "el",
									p: {
										a: 0,
										k: [
											0,
											0
										]
									},
									s: {
										a: 0,
										k: [
											70,
											70
										]
									}
								},
								{
									ty: "gf",
									o: {
										a: 0,
										k: 100
									},
									s: {
										a: 0,
										k: [
											-12.5472,
											-35
										]
									},
									e: {
										a: 0,
										k: [
											17.1698,
											35
										]
									},
									g: {
										p: 2,
										k: {
											a: 0,
											k: [
												0,
												1,
												0.831373,
												0.4,
												1,
												0.756863,
												0.462745,
												0.019608
											]
										}
									},
									t: 1
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									p: {
										a: 0,
										k: [
											35,
											35.198784
										]
									}
								}
							]
						},
						{
							ty: "tr",
							o: {
								a: 0,
								k: 100
							}
						}
					]
				}
			]
		}
	]
};

export { data as default };
//# sourceMappingURL=smiley.partial.json.js.map
